import React, { useState } from "react";
import Modal from "../../../component/ui/modal";
import TextInput from "../../../component/element/forms/TextInput";
import {
  ICreateCompanyBranchUser,
  ICreateCompanyBranchUserError,
} from "../../../store/types/company";
import { createCompanyBranchUser } from "../../../services/apis/company";
import { useAppDispatch, useAppSelector } from "../../../store";
import SelectOption from "../../../component/element/forms/SelectOption";

type IAddUser = {
  show: boolean;
  isClose: () => void;
};

const AddUser = ({ show, isClose }: IAddUser) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [branchId, setBranchId] = React.useState<string>("");
  const company = useAppSelector(({ company }) => company.company);
  const [user, setUser] = useState<ICreateCompanyBranchUser>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [error, setError] = useState<ICreateCompanyBranchUserError>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const onValidate = () => {
    let valid = true;
    const newError: ICreateCompanyBranchUserError = {
      name: "",
      email: "",
      phone: "",
      address: "",
    };

    if (!user.name) {
      newError.name = "error: this field is required";
      valid = false;
    }
    if (!user.email) {
      newError.email = "error: this field is required";
      valid = false;
    }
    if (!user.phone) {
      newError.phone = "error: this field is required";
      valid = false;
    }
    if (!user.address) {
      newError.address = "error: this field is required";
      valid = false;
    }

    setError(newError);
    return valid;
  };

  const clear = () => {
    setUser({
      name: "",
      email: "",
      phone: "",
      address: "",
    });
  };

  const handleOk = async () => {
    if (!onValidate()) return;
    setLoading(true);
    try {
      await createCompanyBranchUser(branchId, user, dispatch);
      clear();
    } catch (error) {
      console.error("Error creating branch user:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Branch Employee"
      open={show}
      onClose={() => {
        clear();
        isClose();
      }}
      onOkClick={handleOk}
      isLoading={loading}
    >
      <div className="space-y-4">
        <SelectOption
          label="Branches"
          placeholder="Choose branch"
          items={
            company?.branch?.map((branch) => ({
              id: branch.id, // add the id property
              name: branch.company_address, // add the name property
            })) || []
          }
          onChange={(value) => setBranchId(value)}
          value={branchId}
        />

        <TextInput
          label="Name"
          name="name"
          value={user.name}
          type="text"
          status={error.name}
          placeholder="Name"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Email"
          name="email"
          value={user.email}
          type="email"
          status={error.email}
          placeholder="Email"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Phone"
          name="phone"
          value={user.phone}
          type="text"
          status={error.phone}
          placeholder="Phone"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Address"
          name="address"
          value={user.address}
          type="text"
          status={error.address}
          placeholder="Address"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
      </div>
    </Modal>
  );
};

export default AddUser;
